import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import CollapsibleNav from "./components/CollapsibleNav";

const Navbar = () => {
	return (
		<div className='uiowa-navbar'>
			<div className='top'>
				<div className='content'>
					<div className='logo-container'>
						<h2>UIOWA</h2>
					</div>
					<div className='links-wrapper'>
						<div className='links'>
							<Link>Apply</Link>
							<Link>Visit</Link>
							<Link>Request Info</Link>
						</div>
						<div className='search d-flex align-items-center gap-2'>
							<i
								class='fa fa-search'
								style={{ fontSize: "1.4rem" }}
								aria-hidden='true'
							></i>
							<p>SEARCH</p>
						</div>
					</div>
				</div>
			</div>
			<div className='bottom'>
				<CollapsibleNav />
			</div>
		</div>
	);
};

export default Navbar;
